<template>
  <div class="beach-modules">
    <div class="mainbackground"></div>

    <div v-if="modalOpened" class="madalbackground" @click="closeModals"></div>

    <div class="container">
      <transition tag="div" name="slideUp">
        <div class="mandatory-modal d-flex flex-column mx-auto p-2" v-if="infoModal">

          <div class="align-items-center d-flex flex-row-reverse justify-content-end title">
            <p>{{namemodal}}</p>
            <img :src="`https://kishoto.ir/dtr/approid/img/${imagemodal}`">
          </div>

          <!--<div class="d-flex flex-row" @if="gallerymodal">
            <img :src="`https://kishoto.ir/dtr/approid/img/${gallerymodal}`">
          </div>-->

          <div class="desc">
            <p v-html="desmodal"></p>
          </div>

        </div>
      </transition>
    </div>

    <!--</transition>-->
    <!--edit profile and new user forced-->
    <div class="main-beach-items d-flex flex-column">

      <router-link tag="div" :to="{name: 'payment',params: { id:0,type:'بازی های ساحلی و بادی',title:name,image:image,des:pack_des,price:price}}" class="beach-games-top">
        <img src="~@/assets/img/events/beach/cabin1.png">
      </router-link>

      <div class="beach-middle">
        <img class="background-main" src="~@/assets/img/events/beach/saheli_back1.jpg">
        <div class="items-beach-all">

        <!--<div v-for="item in lists"
             :class="[(item.id%2 === 0) ? 'd-flex flex-row justify-content-around item-beach-container main-item'+item.id : (item.id%3===0) ? 'd-flex flex-row justify-content-start item-beach-container main-item'+item.id :  'd-flex flex-row justify-content-end item-beach-container main-item'+item.id ]">

          <div :class="'item'+item.id" class="inner-beach-item" @click="openModal(item.name,item.des,item.image,item.gallery == null ? item.gallery[0].url : null)">
            <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${item.image}`'></div>
            <p class="beach-title">{{item.name}}</p>
          </div>
        </div>-->

        <div
               :class="'d-flex flex-row justify-content-center item-beach-container main-item'+lists[0].id">

            <div :class="'item'+lists[0].id" class="inner-beach-item" @click="openModal(lists[0].name,lists[0].des,lists[0].image,lists[0].gallery == null ? lists[0].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[0].image}`'></div>
              <p class="beach-title">{{lists[0].name}}</p>
            </div>
        </div>


          <div
               :class="'d-flex flex-row justify-content-around item-beach-container main-item'+lists[1].id">

            <div :class="'item'+lists[1].id" class="inner-beach-item" @click="openModal(lists[1].name,lists[1].des,lists[1].image,lists[1].gallery == null ? lists[1].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[1].image}`'></div>
              <p class="beach-title">{{lists[1].name}}</p>
            </div>

            <div :class="'item'+lists[2].id" class="inner-beach-item" @click="openModal(lists[2].name,lists[2].des,lists[2].image,lists[2].gallery == null ? lists[2].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[2].image}`'></div>
              <p class="beach-title">{{lists[2].name}}</p>
            </div>

          </div>


          <div
               :class="'d-flex flex-row justify-content-end item-beach-container main-item'+lists[3].id">

            <div :class="'item'+lists[3].id" class="inner-beach-item" @click="openModal(lists[3].name,lists[3].des,lists[3].image,lists[3].gallery == null ? lists[3].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[3].image}`'></div>
              <p class="beach-title">{{lists[3].name}}</p>
            </div>

          </div>

          <div
              :class="'d-flex flex-row justify-content-between item-beach-container main-item'+lists[4].id">

            <div :class="'item'+lists[4].id" class="inner-beach-item" @click="openModal(lists[4].name,lists[4].des,lists[4].image,lists[4].gallery == null ? lists[4].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[4].image}`'></div>
              <p class="beach-title">{{lists[4].name}}</p>
            </div>

            <div :class="'item'+lists[5].id" class="inner-beach-item" @click="openModal(lists[5].name,lists[5].des,lists[5].image,lists[5].gallery == null ? lists[5].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[5].image}`'></div>
              <p class="beach-title">{{lists[5].name}}</p>
            </div>

          </div>

          <div
              :class="'d-flex flex-row justify-content-start item-beach-container main-item'+lists[6].id">

            <div :class="'item'+lists[6].id" class="inner-beach-item" @click="openModal(lists[6].name,lists[6].des,lists[6].image,lists[6].gallery == null ? lists[6].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[6].image}`'></div>
              <p class="beach-title">{{lists[6].name}}</p>
            </div>

          </div>

          <div
              :class="'d-flex flex-row justify-content-between item-beach-container main-item'+lists[7].id">

            <div :class="'item'+lists[7].id" class="inner-beach-item" @click="openModal(lists[7].name,lists[7].des,lists[7].image,lists[7].gallery == null ? lists[7].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[7].image}`'></div>
              <p class="beach-title">{{lists[7].name}}</p>
            </div>

            <div :class="'item'+lists[8].id" class="inner-beach-item" @click="openModal(lists[8].name,lists[8].des,lists[8].image,lists[8].gallery == null ? lists[8].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[8].image}`'></div>
              <p class="beach-title">{{lists[8].name}}</p>
            </div>
          </div>

          <div
              :class="'d-flex flex-row justify-content-end item-beach-container main-item'+lists[9].id">

            <div :class="'item'+lists[9].id" class="inner-beach-item" @click="openModal(lists[9].name,lists[9].des,lists[9].image,lists[9].gallery == null ? lists[9].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[9].image}`'></div>
              <p class="beach-title">{{lists[9].name}}</p>
            </div>

          </div>


          <div
              :class="'d-flex flex-row justify-content-around item-beach-container main-item'+lists[10].id">

            <div :class="'item'+lists[10].id" class="inner-beach-item" @click="openModal(lists[10].name,lists[10].des,lists[10].image,lists[10].gallery == null ? lists[10].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[10].image}`'></div>
              <p class="beach-title">{{lists[10].name}}</p>
            </div>

            <div :class="'item'+lists[11].id" class="inner-beach-item" @click="openModal(lists[11].name,lists[11].des,lists[11].image,lists[11].gallery == null ? lists[11].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[11].image}`'></div>
              <p class="beach-title">{{lists[11].name}}</p>
            </div>
          </div>


          <div
              :class="'d-flex flex-row justify-content-center item-beach-container main-item'+lists[12].id">

            <div :class="'item'+lists[12].id" class="inner-beach-item" @click="openModal(lists[12].name,lists[12].des,lists[12].image,lists[12].gallery == null ? lists[12].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[12].image}`'></div>
              <p class="beach-title">{{lists[12].name}}</p>
            </div>

          </div>

          <div
              :class="'d-flex flex-row justify-content-start item-beach-container main-item'+lists[13].id">

            <div :class="'item'+lists[13].id" class="inner-beach-item" @click="openModal(lists[13].name,lists[13].des,lists[13].image,lists[13].gallery == null ? lists[13].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[13].image}`'></div>
              <p class="beach-title">{{lists[13].name}}</p>
            </div>

          </div>


          <div
              :class="'d-flex flex-row justify-content-around item-beach-container main-item'+lists[14].id">

            <div :class="'item'+lists[14].id" class="inner-beach-item" @click="openModal(lists[14].name,lists[14].des,lists[14].image,lists[14].gallery == null ? lists[14].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[14].image}`'></div>
              <p class="beach-title">{{lists[14].name}}</p>
            </div>

            <div :class="'item'+lists[15].id" class="inner-beach-item" @click="openModal(lists[15].name,lists[15].des,lists[15].image,lists[15].gallery == null ? lists[15].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[15].image}`'></div>
              <p class="beach-title">{{lists[15].name}}</p>
            </div>
          </div>



          <div
              :class="'d-flex flex-row justify-content-center item-beach-container main-item'+lists[16].id">

            <div :class="'item'+lists[16].id" class="inner-beach-item" @click="openModal(lists[16].name,lists[16].des,lists[16].image,lists[16].gallery == null ? lists[16].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[16].image}`'></div>
              <p class="beach-title">{{lists[16].name}}</p>
            </div>

          </div>

         <!-- <div
              :class="'d-flex flex-row justify-content-around item-beach-container main-item'+lists[17].id">

            <div :class="'item'+lists[17].id" class="inner-beach-item" @click="openModal(lists[17].name,lists[17].des,lists[17].image,lists[17].gallery == null ? lists[17].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[17].image}`'></div>
              <p class="beach-title">{{lists[17].name}}</p>
            </div>

            <div :class="'item'+lists[17].id" class="inner-beach-item" @click="openModal(lists[17].name,lists[17].des,lists[17].image,lists[17].gallery == null ? lists[17].gallery[0].url : null)">
              <div class="beach-image beach-image d-flex justify-content-center"><img class="beach-img" :src='`https://kishoto.ir/dtr/approid/img/${lists[17].image}`'></div>
              <p class="beach-title">{{lists[17].name}}</p>
            </div>
          </div>-->

        </div>


      </div>

    </div>


  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
     /* lists: [
      {
        "id": "10",
        "name": "مسابقه فوتبال ساحلی",
        "des": "فوتبال ساحلی یکی از  ورزش های مهیج برای خانواده ها در ساحل است .\r\nاین مسابقات با 5 بازیکن ( یک دروازه‌بان) در 3 وقت 12 دقیقه‌ای برگزار میشود",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/10.png",
        "gallery": [
          {
            "url": "saheli/10-1.jpg"
          }
        ]
      },
      {
        "id": "11",
        "name": "مسابقات پرش روی تشک بادی",
        "des": " این مسابقه می تواند بر روی تشک بادی انجام شود و یا توسط تشک بادی بر روی آب انجام شود .\r\nاین مسابقه می تواند هم برای کودکان و هم برای بزرگسالان لحظاتی جذاب و پر از خاطرات خوش را رقم بزند\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/11.png",
        "gallery": []
      },
      {
        "id": "12",
        "name": "مسابقات سرسره لغزان و پرش در آب",
        "des": "مسابقه ی سرسره ی لغزان شباهت زیادی به سرسره های پارک ابی دارد با این تفاوت که در  ایندفعه شما به دریا انداخته میشوید \r\n این مسابقه می تواند هم برای کودکان و هم برای بزرگسالان لحظاتی جذاب و پر از خاطرات خوش را رقم بزند\r\n*این مسابقه مخصوص اقایان می باشد *",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/12.png",
        "gallery": []
      },
      {
        "id": "13",
        "name": "مسابقه فوتبال صابونی",
        "des": " در این مسابقه فقط کافی است که زمین مخصوص بازی فوتبال  را طراحی نمود و پس از آن با اجرای آن مسابقه شرایطی مفرح برای هر یک ازبازیکنان و یا تماشاچیان رقم زد .\r\nاین مسابقه می تواند هم برای نوجوانان و هم برای بزرگسالان لحظاتی جذاب و پر از خاطرات خوش را رقم بزند\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/13.png",
        "gallery": []
      },
      {
        "id": "14",
        "name": "مسابقات تنیس ساحلی",
        "des": " این مسابقات در ساحل و برگزار خواهد شد و تنها نیاز به تور و راکت دارد . این مسابقه به صورت چهار نفره برگزار خواهد شد و امتیازات آن مانند مسابقات تنیس محاسبه میگردد .",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/14.png",
        "gallery": []
      },
      {
        "id": "15",
        "name": "فوتبال دستی انسانی",
        "des": "با توجه به تنها داشتن زمین مخصوص برای این مسابقه  می توان شرایطی کاملا مفرح وشاد برای هر یک از بازیکنان و همچنین تماشاگران این مسابقه رقم زد   .",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/15.png",
        "gallery": []
      },
      {
        "id": "16",
        "name": "مسابقه مینی گلف ساحلی",
        "des": "دراین رقابت  در ساحل ، زمین های مینی گلف طراحی می گردد و به وسیله توپ های پلاستیکی  و  چوب های مخصوص گلف هر یک از بازیکنان مشغول به بازی می شوند . لازم به ذکر است که این مسابقه \r\nمی تواند هم برای کودکان و هم برای بزرگسالان برگزار شود\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/16.png",
        "gallery": []
      },
      {
        "id": "17",
        "name": "مسابقات فریزبی گلف",
        "des": "در این مسابقه اهدافی را در ساحل در نظر می‌گیریم  و هر بازیکن می بایست به سمت این اهداف ، فریزبی را پرتاب نماید . با توجه به نزدیکی هر پرتاب به اهداف در نظر گرفته شده ، امتیاز مناسب به آن شخص داده خواهد شد .\r\n این مسابقه نیز هم در رده کودکان و هم بزرگسالان قابل برگزاری است .\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/17.png",
        "gallery": []
      },
      {
        "id": "18",
        "name": "مسابقه چالش پر کردن سطل آب با قاشق",
        "des": "وسایل مورد نیاز : سطل و ابزاری مانند قاشق پلاستیکی  \r\nمهارت های توسعه یافته :   تعاون ، چابکی ، ارتباط  هرچه بیشتر اعضای حرکتی بدن با مغز\r\n مسابقه حرکات لیمبو\r\n این مسابقه در واقع بعد از گذاشتن یک نوار در ارتفاع مشخص ،  هر شخص می‌بایست  به همراه حرکات موزون از زیر آن رد شود . در دور های بعدی ، بازیکنان از ارتفاع های پایین تر عبور خواهند کرد تا زمانی که دیگر توان عبور از  این ارتفاع را نداشته باشند .\r\n این مسابقه نیاز به موسیقی و همچنین حرکات موزون در  طول برگزاری دارد .\r\n وسایل مورد نیاز :  نوار یا میله پلاستیکی به همراه موسیقی\r\n مهارت های توسعه یافته : تعادل ، تجربه افتادن ، خندیدن  و شادی بی حد و حصر در لحظه\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/18.png",
        "gallery": []
      },
      {
        "id": "19",
        "name": "مسابقه حرکات لیمبو",
        "des": "این مسابقه در واقع بعد از گذاشتن یک نوار در ارتفاع مشخص ،  هر شخص می‌بایست  به همراه حرکات موزون از زیر آن رد شود . در دور های بعدی ، بازیکنان از ارتفاع های پایین تر عبور خواهند کرد تا زمانی که دیگر توان عبور از  این ارتفاع را نداشته باشند .\r\n این مسابقه نیاز به موسیقی و همچنین حرکات موزون در  طول برگزاری دارد .\r\n وسایل مورد نیاز :  نوار یا میله پلاستیکی به همراه موسیقی\r\n مهارت های توسعه یافته : تعادل ، تجربه افتادن ، خندیدن  و شادی بی حد و حصر در لحظه\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/19.png",
        "gallery": []
      },
      {
        "id": "20",
        "name": "بولینگ ساحلی",
        "des": "در این چالش می‌توان در ساحل گوی های مخصوص بولینگ را جا گذاری کرده و پس از آن توپ هایی را به سمت آنها پرتاب نمود . این مسابقه می تواند برای کودکان و همچنین بزرگسالان جذابیت داشته باشد .\r\n وسایل مورد نیاز :  توپ های بادی یا پلاستیکی موانع پلاستیکی\r\n مهارت های توسعه یافته :  دقت ، هماهنگی چشم ، دست به مغز مفرح\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/20.png",
        "gallery": []
      },
      {
        "id": "21",
        "name": "طناب کشی آبی و ساحلی",
        "des": "وسایل مورد نیاز : پایه فلزی و طناب\r\n مهارت های توسعه یافته :  حفظ تعادل ، تقویت قوای عضلانی ، کار تیمی\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/21.png",
        "gallery": []
      },
      {
        "id": "22",
        "name": "بازی حباب ها",
        "des": "این برنامه برای همه سنین قابل اجرا می باشد . حباب ها توسط دستگاه حباب ساز در فضای آزاد پخش خواهد شد  و فضای شاد و مفرح را برای تمامی مردم  رقم خواهد کرد",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/22.png",
        "gallery": []
      },
      {
        "id": "23",
        "name": "مسابقات باکه ( bocce )",
        "des": "  این مسابقه به صورت تک نفره برگزار می گردد و در هر مکان مسابقه هر بازیکن دو توپ را در اختیار دارد ابتدای هم اول را پرتاب می کند و  بازیکنان می بایست توپ دوم را به سمت توپ اول پرتاب کند .\r\nبا توجه به فاصله هر دو توپ با هم ، امتیاز مشخصی به هر بازیکن داده خواهد شد .این مسابقه در ده راند برگزار خواهد گردید .  نفر اول با توجه به امتیاز محاسبه شده مشخص  خواهد شد\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/23.png",
        "gallery": []
      },
      {
        "id": "24",
        "name": "مسابقه طراحی مسیر رودخانه ساحلی",
        "des": "در این مسابقه کودکان با کمک سطل وچنگک های  مخصوص شن ،  ابتدا سدهای  شنی را خواهند ساخت  و سپس مسیری را به عنوان رودخانه احداث می کنند  . \r\nپس از این مرحله قایق های  کاغذی را بر روی دریاچه های کوچک پشت سدها قرار خواهند داد و سد را باز می‌کند هر یک از بازیکنان که قایق او  به انتهای مسیر برسد برنده این مسابقه خواهد بود . لازم به ذکر است هر کدام از بازیکنان تنها سه قایق کاغذی خواهند داشت .\r\n وسایل مورد نیاز: سطل وچنگک مخصوص شن و کاغذ\r\n مهارت های توسعه یافته : خلاقیت ، ایده پردازی ، شناخت بیشتر محیط\r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/24.png",
        "gallery": []
      },
      {
        "id": "25",
        "name": "مسابقه موسیقی و توپ \r\n(beach ball hot potato)",
        "des": "در این مسابقه گروه های زیادی از نفرات در کنار هم ، توپ را یک به یک به هم دیگر واگذار می‌کنند و DJ و یا یک فرد با چشمان بسته موسیقی را هر بار قطع می کند ، پس از قطع موسیقی ، هر شخص که توپ در دستش باشد بازی را واگذار خواهد کرد و آخرین نفری که بماند برنده این مسابقه خواهد بود .\r\nوسایل مورد نیاز : توپ پلاستیکی و یا بادی\r\nمهارت های توسعه یافته : سرعت عمل ،  شادی ، تفریح \r\n",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/25.png",
        "gallery": []
      },
      {
        "id": "26",
        "name": "مسابقه والیبال ساحلی",
        "des": "در مسابقات رسمی والیبال ساحلی هر تیم از دوبازیکن تشکیل میشود و مربی و بازیکن ذخیره نیز حضور ندارند. اما در مسابقات تفریحی و غیر رسمی معمولا تیم ها بیش از دو بازیکن دارند و این تعداد تا 4  نفر نیز قابل افزایش است \r\n ",
        "count": "200",
        "price": "150000",
        "steps": "",
        "image": "saheli/26.png",
        "gallery": []
      }
    ],*/
      lists:[],
      modalOpened:false,
      infoModal:false,

      namemodal:null,
      desmodal:null,
      imagemodal:null,
      gallerymodal:null,

      id:null,
      name:null,
      des:null,
      pack_des:null,
      steps:null,
      price:null,

      image:"logo1.png"
    };
  },
  beforeMount(){
    this.getGameItems();
  },
  computed: {

  },
  methods: {
    async getGameItems() {

      /*let fd = new FormData();
      fd.append("get_list_games_saheli", 2);*/

      const response = await this.$ApiServiceLayer.post("get_list_games_saheli");
      console.log(response);

      if (response.status_code === 200) {
        this.lists = response.list;

        this.des = response.des;
        this.name = response.name;
        this.price = response.price;
        this.pack_des = response.pack_des;

        console.log(this.lists);
      }
    },
    closeModals() {
      this.modalOpened = false;
      this.infoModal = false;
    },
    openModal(name,des,image,gallery){
      this.infoModal = true;
      this.modalOpened = true;

      this.namemodal = name;
      this.desmodal = des;
      this.imagemodal = image;
      this.gallerymodal = gallery;
    },
    closePaymentModal(){
      this.modalOpened = false;
      this.infoModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.beach-modules {
  width: 100%;
  min-height: 100%;
  height: auto;
  //height: 329vh;
  overflow-y: auto;

   /* background-image: url("~@/assets/img/bg/fifa_t_back.jpg");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;*/
  /*  background: url("~@/assets/img/bg/fifa_t_back.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;*/

  //transform: translate(-50%, -50%);

  .mandatory-modal {
    position: fixed;
    height: 500px;
    width: 97%;
    background-color: #fff;
    border-radius: 10px;
    padding: 0px;
    direction: rtl;
    z-index: 2;
    overflow-y:scroll;
    overflow-x:hidden;
    border: 1px dashed #80808033;
    bottom: 8px;
    left: 0;
    right: 0;
    .title {
      width: 100%;
      height: auto;
      /* background-color: blue; */
      /* margin-top: 40px; */
      /* position: relative; */

      text-align: center;
      margin-bottom: 28px;
      p {
        padding: 10px 20px;
        background-color: white;
        font-family: "sansb";
        font-size: 20px;
        font-weight: bold;
        text-align: justify;
      }
      img{
        width: 83px;
        height: 83px;
      }
    }
    .desc {
      width: 100%;
      padding: 0px;
      text-align: right;
      margin-top: 20px;
      padding-bottom: 30px;
      p {
        font-family: "sans";
        font-size: 17px;
        line-height: 28px;
        white-space: pre-line;
      }
    }
    .image-box{
      img{
        width: 135px;
        height: 180px;
      }
    }
    .input-container{
      position: fixed;
      bottom: 0px;
      height: auto;
      background: #ffffff;
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      padding: 0px 0px 7px 9px;
    }
  }
  .main-beach-items{
  .beach-games-top{
    /*background-image: url("~@/assets/img/events/beach/cabin1.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;*/
    width: 100%;
    height: 100%;
    img{
      width: 100%;
      //height:auto;
    }
  }

  .beach-middle{
   /* background-image: url("~@/assets/img/events/beach/saheli_back.jpg");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;*/
    width: 100%;
    height: 100%;
    img.background-main{
      width: 100%;
      position: relative;
      bottom: 47px;
      z-index: -1;
      //height: 300vh;
      height: 240vh;
    }
    .items-beach-all{
      position: absolute;
      top: 29%;
      width: 100%;
      /*width: 100%;
      position: absolute;
      top: 0;
      z-index: 1;*/
        /*.item-beach-container{
          position: relative;
          z-index: 1 !important;*/
          .inner-beach-item{
            width: max-content;
            position: relative;
            .beach-image{
              .beach-img{
                width: 95px;
                height: 96px;
              }
            }
            .beach-title {
              background: #fff3e0b8;
              border-radius: 10px;
              padding: 2px;
              width: 137px;
              text-align: center;
            }

          }
       // }

/*      .item10 {
        left: 89px;
      }
      .item11 {
        left: 200px;
        bottom: 46px;
      }
      .item12 {
        left: 78px;
        bottom: 114px;
      }

      .item13{
        left: 78px;
        bottom: 114px;
      }*/

    }
  }
}



  .madalbackground{
    width: 100%;
    height: 100%;
    background: #0000006e;
    position: fixed;
    z-index: 2;
  }
  .mainbackground{
    width: 100%;
    height: 157vh;
    position: fixed;
    z-index: -2;
    background: #0597e9;
  }
}
</style>
